import { TableColumn } from 'react-data-table-component';
import { ScoreBoardData } from '../../../types/Scoring';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { TFunction } from 'i18next';

export const getUserColumn = (t: TFunction): TableColumn<ScoreBoardData['rows'][0]> => {
  return {
    name: t('scoring.totalTable.user') || 'User',
    selector: (row) => row.user.fullName,
    sortable: true,
    sortField: 'user.fullName',
    cell: (row) => {
      const nameRowId = `scorings-${row.user.id}`;
      return (
        <div className="font-weight-bold sticky-column w-100 d-flex justify-space-between align-items-center">
          <p className="m-0">{row.user.fullName}</p>

          <Button id={nameRowId} size="xs" color="primary" className="ms-auto me-0">
            <i className="fa fa-info-circle" />
          </Button>
          <UncontrolledTooltip
            target={nameRowId}
            placement="left"
            container="body"
            delay={{ show: 50, hide: 50 }}
            style={{
              minWidth: '300px',
            }}
          >
            <div className="d-flex flex-column text-start">
              <div>Email: {row.user.email}</div>
              <div>Telegram: {row.user.telegram}</div>
            </div>
          </UncontrolledTooltip>
        </div>
      );
    },
    width: '200px',
    minWidth: '200px',

    style: {
      position: 'sticky',
      left: 0,
      // backgroundColor: 'var(--bs-dark)',
      zIndex: 10,
      borderRight: '3px solid #dee2e6',
    },
  };
};
